import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Node.js modules are a type of `}<a parentName="p" {...{
        "href": "about-packages-and-modules"
      }}>{`package`}</a>{` that can be published to npm.`}</p>
    <h2>{`Overview`}</h2>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#create-a-package-json-file"
        }}>{`Create a `}<inlineCode parentName="a">{`package.json`}</inlineCode>{` file`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#create-the-file-that-will-be-loaded-when-your-module-is-required-by-another-application"
        }}>{`Create the file that will be loaded when your module is required by another application`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "#test-your-module"
        }}>{`Test your module`}</a></li>
    </ol>
    <h2>{`Create a `}<inlineCode parentName="h2">{`package.json`}</inlineCode>{` file`}</h2>
    <ol>
      <li parentName="ol">{`To create a `}<inlineCode parentName="li">{`package.json`}</inlineCode>{` file, on the command line, in the root directory of your Node.js module, run `}<inlineCode parentName="li">{`npm init`}</inlineCode>{`:`}
        <ul parentName="li">
          <li parentName="ul">{`For `}<a parentName="li" {...{
              "href": "about-scopes"
            }}>{`scoped modules`}</a>{`, run `}<inlineCode parentName="li">{`npm init --scope=@scope-name`}</inlineCode></li>
          <li parentName="ul">{`For `}<a parentName="li" {...{
              "href": "creating-and-publishing-unscoped-public-packages"
            }}>{`unscoped modules`}</a>{`, run `}<inlineCode parentName="li">{`npm init`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ol">{`Provide responses for the required fields (`}<inlineCode parentName="li">{`name`}</inlineCode>{` and `}<inlineCode parentName="li">{`version`}</inlineCode>{`), as well as the `}<inlineCode parentName="li">{`main`}</inlineCode>{` field:`}
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`name`}</inlineCode>{`: The name of your module.`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`version`}</inlineCode>{`: The initial module version. We recommend following `}<a parentName="li" {...{
              "href": "about-semantic-versioning"
            }}>{`semantic versioning guidelines`}</a>{` and starting with `}<inlineCode parentName="li">{`1.0.0`}</inlineCode>{`.`}</li>
        </ul>
      </li>
    </ol>
    <p>{`For more information on `}<inlineCode parentName="p">{`package.json`}</inlineCode>{` files, see "`}<a parentName="p" {...{
        "href": "creating-a-package-json-file"
      }}>{`Creating a package.json file`}</a>{`".`}</p>
    <h2>{`Create the file that will be loaded when your module is required by another application`}</h2>
    <p>{`In the file, add a function as a property of the `}<inlineCode parentName="p">{`exports`}</inlineCode>{` object. This will make the function available to other code:`}</p>
    <pre><code parentName="pre" {...{}}>{`exports.printMsg = function() {
  console.log("This is a message from the demo package");
}
`}</code></pre>
    <h2>{`Test your module`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Publish your package to npm:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`For `}<a parentName="li" {...{
              "href": "creating-and-publishing-private-packages#publishing-private-packages"
            }}>{`private packages`}</a>{` and `}<a parentName="li" {...{
              "href": "creating-and-publishing-unscoped-public-packages#publishing-unscoped-public-packages"
            }}>{`unscoped packages`}</a>{`, use `}<inlineCode parentName="li">{`npm publish`}</inlineCode>{`.`}</li>
          <li parentName="ul">{`For `}<a parentName="li" {...{
              "href": "creating-and-publishing-scoped-public-packages#publishing-scoped-public-packages"
            }}>{`scoped public packages`}</a>{`, use `}<inlineCode parentName="li">{`npm publish --access public`}</inlineCode></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, create a new test directory outside of your project directory.`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`mkdir test-directory
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Switch to the new directory:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`cd /path/to/test-directory
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the test directory, install your module:`}</p>
        <pre parentName="li"><code parentName="pre" {...{}}>{`npm install <your-module-name>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the test directory, create a `}<inlineCode parentName="p">{`test.js`}</inlineCode>{` file which requires your module and calls your module as a method.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`On the command line, run `}<inlineCode parentName="p">{`node test.js`}</inlineCode>{`. The message sent to the console.log should appear.`}</p>
      </li>
    </ol>
    <h2>{`Resources`}</h2>
    <iframe src="https://www.youtube.com/embed/3I78ELjTzlQ" frameBorder="0" allowFullScreen></iframe>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      